import React, { useEffect, useRef } from 'react';

import { apiContainer } from '@vlabs/api-bindings';
import { ButtonWithPermissions } from '@vlabs/monokit/shared/ui/button-with-permissions';
import { useModal, Stepper, Page } from '@vlabs/uikit';
import cn from 'classnames';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import { useForm, FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { StepCallbacksPolicy } from '@vlabs/monokit/entities/handlers/ui/steps/';

import { permissions } from '@vlabs/shared/config';
import { useSteppedForm } from '@vlabs/shared/hooks';

import { showResourceIntensiveTaskPopup } from '../showResourceIntensiveTaskPopup';
import { StepCrossMatch } from './StepCrossMatch';
import '../styles/shared.styles.sass';

const defaultValues = {
  limit: 3,
  threshold: 50,
  notification_policy: {
    task_callbacks: [],
  },
};

// Разделение на два компонента необходимо чтобы избежать смешивания логики и
// чтобы избежать ошибок с активным шагом, который не сбрасывается при закрытии модального окна

function StepperModal({ onSubmit }) {
  const { t } = useTranslation();
  const form = useForm({ defaultValues, mode: 'onChange' });
  const prevForm = useRef(defaultValues);
  const steps = [StepCrossMatch, StepCallbacksPolicy];

  useEffect(() => {
    prevForm.current = defaultValues;
    form.reset(defaultValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.reset, prevForm]);

  const stepper = useSteppedForm({ form, steps, onSubmit });

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <Page
          className={cn('TaskStepperModal__Page', 'CrossMatchForm')}
          title={t('tasks:cross_matching')}
        >
          <Stepper
            {...stepper}
            className={cn('TaskStepperModal__StepperContent')}
          >
            {steps.map((Step) => <Step key={Step.name} />)}
          </Stepper>
        </Page>
      </form>
    </FormProvider>
  );
}

export function CrossMatchWidget({ afterSubmit }) {
  const { t } = useTranslation();
  const modal = useModal();
  const crossmatchTask = async (params) => {
    await apiContainer.lunaClient.tasks.crossmatch(params);
    toast.info(i18next.t('tasks:confirmation.cross_matching'));
  };

  const submitForm = (values) => {
    const onConfirm = async () => {
      await crossmatchTask(values);
      modal.close();
      if (afterSubmit) afterSubmit();
    };
    showResourceIntensiveTaskPopup(onConfirm);
  };
  return (
    <React.Fragment>
      {modal.wrap(<StepperModal onSubmit={submitForm} />)}
      <ButtonWithPermissions
        data-testid="crossMatchingButton"
        onClick={modal.open}
        permissions={{ rules: [permissions.task.creation] }}
      >
        {t('tasks:cross_matching')}
      </ButtonWithPermissions>
    </React.Fragment>
  );
}

CrossMatchWidget.propTypes = {
  afterSubmit: PropTypes.func,
};

CrossMatchWidget.defaultProps = {
  afterSubmit: undefined,
};
